/**
 * Event log window. `log.add(text, kind)` appends an entry with color coding;
 * the window keeps up to N entries and scrolls to the newest.
 */

import type { GameWindow } from './window';

export type LogKind = 'info' | 'combat' | 'stealth' | 'system' | 'warn';

const KIND_COLOR: Record<LogKind, string> = {
  info: '#a0b0c0',
  combat: '#e07070',
  stealth: '#c0e0a0',
  system: '#7fbfe0',
  warn: '#e0b060',
};

export class EventLog {
  private readonly win: GameWindow;
  private readonly list: HTMLUListElement;
  private readonly max: number;

  constructor(win: GameWindow, max = 100) {
    this.win = win;
    this.max = max;
    this.list = document.createElement('ul');
    this.list.className = 'log-list';
    this.win.body.appendChild(this.list);
  }

  add(text: string, kind: LogKind = 'info'): void {
    const li = document.createElement('li');
    li.className = `log-item log-${kind}`;
    li.style.color = KIND_COLOR[kind];
    li.textContent = text;
    this.list.appendChild(li);
    while (this.list.children.length > this.max) {
      this.list.removeChild(this.list.firstChild!);
    }
    this.win.body.scrollTop = this.win.body.scrollHeight;
  }

  clear(): void {
    this.list.innerHTML = '';
  }
}
